module.exports = __webpack_public_path__ + "static/img/20016 (3).004f328.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20016 (3).webp
// module id = EoDa
// module chunks = 14